/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import geometryReducer from "./store/reducers/geometry";
import vehicleReducer from "./store/reducers/vehicles";
import coordinateReducer from "./store/reducers/coordinate";
import authReducer from "./store/reducers/auth";
import visitReducer from "./store/reducers/visit";
import geofenceReducer from "./store/reducers/geofence";
import loadingReducer from "./store/reducers/loading";
import geofenceUtility from "./store/reducers/geofenceUtility";
import userReducer from "./store/reducers/user";
import { BrowserRouter } from "react-router-dom";
import { Amplify , Auth } from "aws-amplify";

// set up configuration for env file
//require("dotenv").config();
process.env.CI = false;

// Redux configuration to see state changes in browser
const composeEnhancers =
  (process.env.NODE_ENV === "development"
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null) || compose;

// Amplify configuration
Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_USERPOOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USERPOOL_WEBCLIENT_ID,
    mandatorySignIn: true,
    authenticationFlowType: "CUSTOM_AUTH",
    cookieStorage: {
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      path: "/",
      expires: 365,
      secure: true,
    },
  },
  Analytics: {
    disabled: true,
  },
});

Auth.configure();

// combine all reducers
const rootReducer = combineReducers({
  geometry: geometryReducer,
  vehicle: vehicleReducer,
  coordinates: coordinateReducer,
  auth: authReducer,
  visit: visitReducer,
  geofence: geofenceReducer,
  ui: loadingReducer,
  geoUtil: geofenceUtility,
  user: userReducer,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

serviceWorker.unregister();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
